module.exports = __webpack_public_path__ + "img/white_calendar.1afe1964.svg";